import { useParams } from "react-router-dom";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { PartnerDashboardProvider } from "./components/partner-dashboard/PartnerDashboard.provider";
import { PartnerDashboard } from "./components/partner-dashboard";

function PartnerDetailsPage() {
  const { partnerId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <PartnerDashboardProvider partnerId={partnerId || ''}>
          <PartnerDashboard />
        </PartnerDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PartnerDetailsPage